import React from 'react';

const ContentContext = React.createContext();

export default ContentContext;
